module.exports = __webpack_public_path__ + "img/icon-opera.b4b964d2.svg";